'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var TableCell = require('../../../node_modules/@material-ui/core/TableCell/TableCell.js');
var classNames = require('classnames');
require('prop-types');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TWO_ROW_HEIGHT = 48;
var styles = {
  condensed: {
    overflow: 'hidden',
    maxHeight: TWO_ROW_HEIGHT
  },
  expanded: {
    minHeight: TWO_ROW_HEIGHT
  }
};

var ExpandableTableCell = function ExpandableTableCell(_ref) {
  var _classNames;

  var classes = _ref.classes,
      children = _ref.children,
      expanded = _ref.expanded,
      className = _ref.className,
      _ref$expansionProps = _ref.expansionProps,
      expansionProps = _ref$expansionProps === void 0 ? {} : _ref$expansionProps,
      props = objectWithoutProperties(_ref, ["classes", "children", "expanded", "className", "expansionProps"]);

  var expansionClassName = expansionProps.className,
      otherExpansionProps = objectWithoutProperties(expansionProps, ["className"]);

  return React__default["default"].createElement(TableCell, _extends["default"]({
    className: className
  }, props), React__default["default"].createElement("div", _extends["default"]({
    className: classNames__default["default"]((_classNames = {}, defineProperty(_classNames, classes.expanded, expanded), defineProperty(_classNames, classes.condensed, !expanded), _classNames), expansionClassName)
  }, otherExpansionProps), children));
};

ExpandableTableCell.defaultProps = {
  expanded: false
};
var ExpandableTableCell$1 = withStyles["default"](styles)(ExpandableTableCell);

exports.TWO_ROW_HEIGHT = TWO_ROW_HEIGHT;
exports["default"] = ExpandableTableCell$1;
